import { NavLink, NavLinkProps, useLocation } from "react-router-dom";
import MJLogo from "@frontend/app/assets/MJLogo.tsx";
import clsx from "clsx";

type StyledNavLinkProps = NavLinkProps & { isActive: boolean };

const StyledNavLink = ({ isActive = false, ...props }: StyledNavLinkProps) => {
  return (
    <NavLink
      {...props}
      className={clsx(
        "nav-link",
        props.className,
        "mr-4 text-center cursor-pointer text-white",
        isActive && "!text-indigo-300 hover:text-indigo-400 transition-colors duration-200"
      )}
    />
  );
};

const MainNav = () => {
  const { pathname } = useLocation();
  return (
    <div className="sticky bottom-0 md:top-0 z-50 border-b glass !rounded-none !border-none w-full !bg-grey-90/50">
      <nav className="flex items-center h-16 px-4 mx-auto max-w-screen-xl">
        <StyledNavLink to="/projects" isActive={pathname === "/projects"}>
          Projects
        </StyledNavLink>

        <NavLink to="/" className="px-5">
          <MJLogo className="text-indigo-500 hover:text-indigo-400 transition-colors duration-200" />
        </NavLink>

        <StyledNavLink to="/contact" isActive={pathname === "/contact"}>
          Contact
        </StyledNavLink>
      </nav>
    </div>
  );
};

export default MainNav;
